var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",staticStyle:{"min-height":"90vh"},attrs:{"fluid":_vm.$vuetify.breakpoint.mdAndUp}},[_c('v-card',[_c('v-card-title',[_vm._v("Chat")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }